import React from "react";
import "./rejectedStore-table.component.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

type props = {
  customers: any;
  first: any;
  sortField: any;
  sortOrder: any;
  totalRecords: any;
  onPage: any;
  onSort: any;
  onFilter: any;
  filters: any;
  loading: any;
  countryBodyTemplate: any;
  representativeBodyTemplate: any;
  actionBodyTemplate: any;
};

const calculateColumnWidth = (numberOfColumns: number) => `${100 / numberOfColumns}%`;

var width = window.screen.width;
var c_rows = 10;
if (width >= 1920) {
  c_rows = 15;
} else if (width >= 1400 || width <= 1600) {
  c_rows = 10;
}

const RejectedStoretable: React.FC<props> = ({
  customers,
  first,
  sortField,
  sortOrder,
  totalRecords,
  onPage,
  onSort,
  onFilter,
  filters,
  loading,
  countryBodyTemplate,
  representativeBodyTemplate,
  actionBodyTemplate,
}) => {
  const numberOfColumns = 4; 
  const columnWidth = calculateColumnWidth(numberOfColumns); 

  return (
    <DataTable
      className="rejected-table-data"
      value={customers}
      lazy
      filterDisplay="row"
      responsiveLayout="scroll"
      paginator={totalRecords >= 10}
      first={first}
      rows={10}
      totalRecords={totalRecords}
      onPage={onPage}
      onSort={onSort}
      sortField={sortField}
      sortOrder={sortOrder}
      onFilter={onFilter}
      filters={filters}
      loading={loading}
    >
      <Column
        field="storename"
        header="Organic Store Name"
        sortable
        filter
        filterPlaceholder="Search by Name"
        style={{ width: columnWidth }} 
      />
      <Column
        field="city"
        sortable
        header="City"
        filter
        filterPlaceholder="Search by City"
        style={{ width: columnWidth }} 
      />
      <Column
        field="storetype"
        header="Store Type"
        body={(rowData) => (
          <span>
            {rowData.storetype.map((type: any, index: any) => (
              <span key={index}>
                {index > 0 && ", "}
                {type}
              </span>
            ))}
          </span>
        )}
        style={{ width: columnWidth }} 
      />
      <Column
        header="Actions"
        className="action_btn"
        body={actionBodyTemplate}
        exportable={false}
        style={{ minWidth: "8rem", width: columnWidth }} 
      />
    </DataTable>
  );
};

export default RejectedStoretable;
